import FeaturedMatches from './FeaturedMatches';
import UpcomingMatches from './UpcomingMatches';
import CallToAction from './CallToAction';

function TodayPage({ matches, loading, timeZone, onViewSchedule, onExplore }) {
  return (
    <>
      <FeaturedMatches matches={matches} loading={loading} timeZone={timeZone} />
      <UpcomingMatches matches={matches} timeZone={timeZone} onViewSchedule={onViewSchedule} />
      <CallToAction onExplore={onExplore} />
    </>
  );
}

export default TodayPage;
